import { Box, Typography, Flex } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { useState } from "react"
import { Link } from "react-router-dom"

import Faq from "areas/info/warranty/faq"
import PeaceOfMind from "areas/info/warranty/peace-of-mind"
import ProtectionCoverage from "areas/info/warranty/protection-coverage"
import WhatsCovered from "areas/info/warranty/whats-covered"
import fetchOrder from "areas/order/hoc/fetch-order"

import CheckoutBox from "./checkout-box"
import ProtectionPlan from "./protection-plan"
import ProtectionProducts from "./protection-products"

const PurchaseWarranty = ({ data }) => {
  const [selectedOffers, setSelectedOffers] = useState({})
  if (data?.errors) {
    return (
      <Flex alignItems="center" contain flexDirection="column" my={4}>
        {data.errors.map((error, i) => (
          <Typography
            fontSize={20}
            fontWeight={600}
            key={i}
            mb={4}
            textAlign="center"
          >
            {error}
          </Typography>
        ))}
        <Typography fontSize="18px" mb={4} textAlign="center">
          Thank you for choosing {sl.config.site_title}.
        </Typography>
        <Box
          as={Link}
          bg="primary"
          color="white"
          data-lc="purchase-warranty"
          fontSize={14}
          p="12px 20px"
          to="/"
        >
          CONTINUE SHOPPING
        </Box>
      </Flex>
    )
  } else {
    return (
      <>
        <ProtectionCoverage />
        <Box contain>
          <ProtectionPlan />
          <Box
            bg="polar"
            mx={{ _: 2, tablet: 0 }}
            my={3}
            px={{ _: "90px", tablet: 0 }}
            py={1}
            textAlign="center"
          >
            <Typography as="h1" fontSize={18}>
              Add Protection To Your Products Below:
            </Typography>
          </Box>
          <ProtectionProducts
            data={data}
            selectedOffers={selectedOffers}
            setSelectedOffers={setSelectedOffers}
          />
          <CheckoutBox mb={8} selectedOffers={selectedOffers} />
          <WhatsCovered />
          <PeaceOfMind />
          <Faq mb={7} />
          <CheckoutBox selectedOffers={selectedOffers} />
        </Box>
      </>
    )
  }
}

PurchaseWarranty.propTypes = {
  data: PropTypes.object,
}

export default fetchOrder(PurchaseWarranty)
